/* The existing Klaviyo embed owns submission, consent, errors and success. */
(() => {
  if (window.nhNewsletterDialog) return;
  window.nhNewsletterDialog = true;
  let cleanup;

  function mount() {
    if (cleanup) cleanup();
    const section = document.querySelector('[data-nh-newsletter]');
    if (!section) return;
    const dialog = section.querySelector('dialog');
    const source = section.querySelector('[data-nh-newsletter-source]');
    const formHost = section.querySelector('[data-nh-newsletter-form]');
    if (!dialog || !source || !formHost || typeof dialog.showModal !== 'function') return;
    const slot = section.querySelector('[data-nh-newsletter-slot]');
    const loading = section.querySelector('[data-nh-newsletter-loading]');
    const unavailable = section.querySelector('[data-nh-newsletter-unavailable]');
    let opener;
    let timer;

    slot.append(formHost);
    source.hidden = true;

    function syncForm() {
      const form = formHost.querySelector('form');
      const ready = !!form && form.textContent.trim().length > 0;
      loading.hidden = ready;
      if (ready) {
        unavailable.hidden = true;
        clearTimeout(timer);
      }
      formHost.querySelectorAll('.nh-newsletter-form__title, .nh-newsletter-form__intro').forEach(row => {
        row.classList.remove('nh-newsletter-form__title', 'nh-newsletter-form__intro');
      });
      if (form && form.querySelector('input[type="email"]')) {
        const rows = form.querySelectorAll('[data-testid="form-row"]');
        if (rows[0]) rows[0].classList.add('nh-newsletter-form__title');
        if (rows[1]) rows[1].classList.add('nh-newsletter-form__intro');
      }
    }
    const observer = new MutationObserver(syncForm);
    observer.observe(formHost, { childList: true, subtree: true, characterData: true });
    syncForm();

    function onOpen(event) {
      const trigger = event.target.closest('[data-nh-newsletter-open]');
      if (!trigger) return;
      event.preventDefault();
      if (dialog.open) return;
      opener = trigger;
      dialog.showModal();
      document.body.classList.add('nh-newsletter-is-open');
      syncForm();
      if (!loading.hidden) {
        clearTimeout(timer);
        timer = setTimeout(() => {
          if (!loading.hidden) {
            loading.hidden = true;
            unavailable.hidden = false;
          }
        }, 15000);
      }
    }
    function onClose() {
      clearTimeout(timer);
      document.body.classList.remove('nh-newsletter-is-open');
      if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    }
    function onDialogClick(event) {
      if (event.target.closest('[data-nh-newsletter-close]')) dialog.close();
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }
    }
    document.addEventListener('click', onOpen);
    dialog.addEventListener('click', onDialogClick);
    dialog.addEventListener('close', onClose);
    cleanup = () => {
      observer.disconnect();
      clearTimeout(timer);
      if (dialog.open) dialog.close();
      document.body.classList.remove('nh-newsletter-is-open');
      document.removeEventListener('click', onOpen);
      dialog.removeEventListener('click', onDialogClick);
      dialog.removeEventListener('close', onClose);
      source.append(formHost);
      source.hidden = false;
      cleanup = null;
    };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, { once: true });
  else mount();
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('[data-nh-newsletter]') && cleanup) cleanup();
  });
})();
